import { render, staticRenderFns } from "./StockStageDaysTable.vue?vue&type=template&id=6f385b8b&"
import script from "./StockStageDaysTable.vue?vue&type=script&lang=js&"
export * from "./StockStageDaysTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports